import { useQuery } from '@tanstack/react-query';
import {
  getTenant,
  getTenantAudit,
  getTenantExtensions,
  getTenantSubscriptions,
  getTenantUsers,
} from '../../api/tenants/getTenant';
import { useEnvironment } from '../useEnvironment/useEnvironment';

export const useTenant = (name: string) => {
  const { environment } = useEnvironment();
  return useQuery({
    queryKey: ['tenant', environment, name],
    queryFn: () => getTenant(environment, name),
    select: ({ data }) => data,
    enabled: Boolean(name),
  });
};

export const useTenantUsers = (name: string) => {
  const { environment } = useEnvironment();
  return useQuery({
    queryKey: ['tenant-users', environment, name],
    queryFn: () => getTenantUsers(environment, name),
    select: ({ data }) => data,
    enabled: Boolean(name),
  });
};

export const useTenantExtensions = (name: string) => {
  const { environment } = useEnvironment();
  return useQuery({
    queryKey: ['tenant-extensions', environment, name],
    queryFn: () => getTenantExtensions(environment, name),
    select: ({ data }) => data,
    enabled: Boolean(name),
  });
};

export const useTenantSubscriptions = (name: string) => {
  const { environment } = useEnvironment();
  return useQuery({
    queryKey: ['tenant-subscriptions', environment, name],
    queryFn: () => getTenantSubscriptions(environment, name),
    select: ({ data }) => data,
    enabled: Boolean(name),
  });
};

export const useTenantAudit = (name: string) => {
  const { environment } = useEnvironment();
  return useQuery({
    queryKey: ['tenant-audit', environment, name],
    queryFn: () => getTenantAudit(environment, name),
    select: ({ data }) => data,
    enabled: Boolean(name),
  });
};
